import React, { useContext } from 'react'
import themeContext from '../../context/theme/ThemeContext'

const Critical = () => {
  const {themeName} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
    >
      <circle cx="5" cy="5.5" r="5" strokeWidth={themeName!="light"?"1":"3"} stroke="#ff0" fill="green"/>
    </svg>
  )
}

export default Critical